import React, { useEffect } from "react";
import PubSub from "pubsub-js";
import Texte from "./Texte";
import TexteImages from "./TexteImages";

const Modules = ({ input }) => {
  // console.log(input);
  useEffect(() => {
    setTimeout(() => {
      _format();
    }, 250);

    window.addEventListener("resize", _format);

    const token = PubSub.subscribe("ROUTE_UPDATE", _format);

    return () => {
      window.removeEventListener("resize", _format);
      PubSub.unsubscribe(token);
    };
  }, []);

  const _format = () => {
    const textes = document.querySelectorAll(".texte-images--texte div.texte");
    // console.log(textes);
    if (textes.length) {
      let maxTexteHeight = 0;
      textes.forEach((el) => {
        //on reset sur la taille originale du texte
        el.querySelector("section.texte").style.minHeight = "unset";
        const height = el.getBoundingClientRect().height;
        el.querySelector("section.texte").style.minHeight = "";
        // console.log(height);
        if (height > maxTexteHeight) maxTexteHeight = height;
      });
      console.log("maxTexteHeight", maxTexteHeight);
      // const imagesHeight = maxTexteHeight;
      document.documentElement.style.setProperty(
        "--maxTexteHeight",
        maxTexteHeight + "px"
      );
    }
  };

  const _renderModules = () => {
    const _modules = input.map((module, i) => {
      // console.log(module._type);
      // console.log(module);
      switch (module._type) {
        case "texteUI":
          return <Texte key={i} input={module.texte} />;
        case "texteImagesUI":
          return (
            <TexteImages key={i} index={i} input={module} len={input.length} />
          );
        default:
          return null;
      }
    });
    return _modules;
  };

  return (
    <div className='modules sm:mbXL'>
      {_renderModules()}
      {/* {_renderModules()} */}
    </div>
  );
};

export default Modules;
